import { apiErrorClear } from '../../../../global/ducks/base-api';
import { ProcessNewHirePost, ProcessNewHirePostWithExistingPerson } from './new-hire-request';

export function NewHireSubmitAction(
	dispatch: any,
	selectedPersonGuid: string,
	values: any,
	nonStip: boolean,
	institutionGuid: string,
	onSubmitSuccess: any,
	institutionClientNumber: string,
) {

	dispatch(apiErrorClear());
	if (selectedPersonGuid)
		ProcessNewHirePostWithExistingPerson(values, selectedPersonGuid, !nonStip, institutionGuid, dispatch, onSubmitSuccess);
	else
		ProcessNewHirePost(values, !nonStip, institutionClientNumber, dispatch, onSubmitSuccess);

}